import React,{useState} from 'react'
import Sets from "../../maxillofacial/desktop/Sets"
import {dataGenerator} from "./data.js";
import i18n from "i18next";

const MiniPlatingLowProfileSets = (props) => {
	const [data, setData] = useState(dataGenerator(i18n.language))
	i18n.on('languageChanged', function(lng) {	
		setData(dataGenerator(lng))
	})
	return (
		<Sets
			title={"miniplatingLowProfile.products.4.name"}
			navigate={"miniplating_low_system"}
			subtitle={"miniplatingLowProfile.products.4.description"}
			sectionTitles={["miniplatingLowProfile.sets.titles.1"]}
			titleExtended={["miniplatingLowProfile.sets.titles.2"]}
			sectionData={[data.dataSection_1]}
		/>
	)
}

export default (MiniPlatingLowProfileSets)